// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"27":"5c14b488","282":"c6dbb1f1","982":"8f95f5da"}[chunkId] + ".css";
};